import { api, mapRows } from "./api";
import { SECTIONS } from "../constants/sections";

export async function loadAllSections() {
  const combined = [...SECTIONS];
  try {
    const res = await api.get("/custom_sections?orderBy=createdAt");
    mapRows(res).forEach((data) => {
      if (!combined.find((s) => s.key === data.key)) {
        combined.push({ id: data.id, ...data });
      }
    });
  } catch (err) {
    console.error("Error loading custom sections:", err);
  }
  return combined;
}
